import { useMemo } from 'react';
import { useCMS } from '../context/CMSContext';
import { useTranslation } from 'react-i18next';

const WA_ICON = (
  <svg viewBox="0 0 32 32" className="h-7 w-7 fill-current" aria-hidden="true">
    <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.26.6 4.46 1.72 6.4L3.2 28.8l6.56-1.68a12.74 12.74 0 0 0 6.24 1.6h.004c7.06 0 12.8-5.74 12.8-12.8s-5.74-12.8-12.8-12.8zm0 23.47h-.004a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-3.89 1 1.04-3.8-.25-.4a10.56 10.56 0 0 1-1.62-5.63c0-5.87 4.78-10.64 10.65-10.64 2.85 0 5.52 1.11 7.53 3.12a10.58 10.58 0 0 1 3.12 7.53c0 5.87-4.78 10.53-10.65 10.53zm5.84-7.9c-.32-.16-1.93-.95-2.23-1.06-.3-.11-.52-.16-.74.16-.22.32-.85 1.06-1.04 1.28-.19.22-.38.24-.7.08-.32-.16-1.36-.5-2.59-1.6-.96-.85-1.6-1.91-1.79-2.23-.19-.32-.02-.5.14-.66.14-.14.32-.38.48-.56.16-.19.22-.32.32-.54.11-.22.05-.4-.03-.56-.08-.16-.72-1.77-.99-2.42-.26-.63-.53-.55-.72-.56l-.62-.01c-.22 0-.56.08-.85.4-.3.32-1.12 1.1-1.12 2.68s1.15 3.11 1.31 3.32c.16.22 2.24 3.55 5.5 4.84.77.33 1.37.53 1.84.68.81.26 1.55.22 2.13.13.65-.1 2-.82 2.28-1.61.28-.79.28-1.47.2-1.61-.08-.14-.3-.22-.62-.38z" />
  </svg>
);

/**
 * Site-wide floating WhatsApp button. Renders only when the CMS has a
 * WhatsApp number configured (cms.site.whatsappNumber). Server-rendered so
 * AI agents and crawlers see the wa.me deep link in raw HTML.
 */
export default function WhatsAppFloat() {
  const { cms, lang } = useCMS();
  const { t, i18n } = useTranslation();

  const number = (cms.site?.whatsappNumber || '').replace(/[^\d]/g, '');

  const text = useMemo(() => {
    const msg = i18n.exists('whatsapp.message')
      ? t('whatsapp.message')
      : 'Hello, I would like to enquire about your advisory services.';
    return msg;
  }, [t, i18n, lang]);

  if (!number) return null;

  const href = `https://wa.me/${number}?text=${encodeURIComponent(text)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg hover:scale-105 hover:shadow-xl transition-all duration-200 animate-[fadeIn_0.4s_ease-out]"
    >
      {WA_ICON}
    </a>
  );
}
